import type { SVGProps } from "react";
export function InputIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m2.32709 2.9757c1.2382-1.22166 2.93894-1.9757 4.81579-1.9757 3.78712 0 6.85712 3.07004 6.85712 6.85713 0 3.78707-3.07 6.85717-6.85712 6.85717-1.87685 0-3.57759-.7541-4.81579-1.9758"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
      <path
        d="m5.42863 11.4415 3.29411-2.80606c.47546-.40503.4674-1.14195-.0168-1.53648l-3.27731-2.6704"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m2 7.10712c-.41421 0-.75.33579-.75.75 0 .41422.33579.75.75.75v-.75zm7.2857.75v-.75h-7.2857v.75.75h7.2857z"
        fill="currentColor"
      />
    </svg>
  );
}
